<template>
  <transition class="flex-1" name="fade-transform" mode="out-in">
    <router-view class="flex-1" />
  </transition>
</template>
<script>
export default {
  name: "EmptyLayout",
};
</script>
